export interface Guideline {
  title: string
  url: string
}

/**
 * Clinical guidelines for treatment and care planning.
 * These guidelines are required for accreditation purposes.
 * Links open in a new browser tab.
 */
export const clinicalGuidelines: Guideline[] = [
  {
    title: 'HSE National Clinical Guidelines',
    url: 'https://www.hse.ie/eng/about/who/cspd/ncps/',
  },
  {
    title: 'ICGP Clinical Guidelines',
    url: 'https://www.icgp.ie/go/clinical_practice/clinical_guidelines',
  },
  {
    title: 'HPRA Clinical Guidelines',
    url: 'https://www.hpra.ie/homepage/medicines/regulatory-information/guidance',
  },
  {
    title: 'NICE Guidelines',
    url: 'https://www.nice.org.uk/guidance',
  },
  {
    title: 'SIGN Guidelines',
    url: 'https://www.sign.ac.uk/our-guidelines/',
  },
]
